<div class="trail-legend-container mat-dialog-custom" [ngClass]="{ snow: !isOrv }">
  <div class="title-container">
    <h1 class="title" i18n>Legend</h1>
    <button
      id="closeDialog"
      class="close button button-link"
      type="button"
      aria-label="close"
      mat-dialog-close="cancel"
      i18n-aria-label
    >
      <img alt="close" ngSrc="/assets/icons/close.svg" i18n-alt />
    </button>
  </div>
  <div class="body-container">
    @if (isOrv) {
      <div class="left">
        <div class="vehicle-class-row">
          <img alt="Any" [ngSrc]="otherImg" i18n-alt />
          <div>
            <div class="title" i18n>Any</div>
            <div class="description" i18n>Any vehicle allowed by local rules and regulations.</div>
          </div>
        </div>

        <div class="vehicle-class-row">
          <img alt="side by side" [ngSrc]="sxsImg" i18n-alt />
          <div>
            <div class="title" i18n>SxS</div>
            <div class="description" i18n>
              Side by side recreational off-road vehicles, excluding highway-licensed vehicles.
            </div>
          </div>
        </div>

        <div class="vehicle-class-row">
          <img alt="side by side 50 inches or less" [ngSrc]="sxs50Img" i18n-alt />
          <div>
            <div class="title" i18n>SxS < 50"</div>
            <div class="description" i18n>Side by side recreational off-road vehicles 50 inches wide or less.</div>
          </div>
        </div>

        <div class="vehicle-class-row">
          <img alt="ATV" [ngSrc]="atvImg" i18n-alt />
          <div>
            <div class="title" i18n>ATV</div>
            <div class="description" i18n>All-Terrain Vehicles 50 inches wide or less, straddled by the rider.</div>
          </div>
        </div>

        <div class="vehicle-class-row">
          <img alt="Dirt Bike" [ngSrc]="dirtBikeImg" i18n-alt />
          <div>
            <div class="title" i18n>Dirt Bike</div>
            <div class="description" i18n>Off-highway motorcycles (single track).</div>
          </div>
        </div>

        <div>
          <div class="no-icon-vehicle-class-row">
            <img alt="Designated Route Paved" [ngSrc]="designatedPavedImg" i18n-alt />
            <div class="title" i18n>Designated Route Paved</div>
          </div>
          <div class="vehicle-class-row">
            <img class="unpaved-img" alt="Designated Route Unpaved" [ngSrc]="designatedUnpavedImg" i18n-alt />
            <div>
              <div class="title" i18n>Designated Route Unpaved</div>
              <div class="description" i18n>
                Roads that allow limited off-road vehicle use. Check local rules before you go. May or may not be
                maintained.
              </div>
            </div>
          </div>
        </div>

        <div class="vehicle-class-row unmaintained-row">
          <img alt="Unmaintained" [ngSrc]="unmaintainedImg" i18n-alt />
          <div>
            <div class="title" i18n>Unmaintained</div>
            <div class="description" i18n>
              Maintained only as-needed (forest service and fire roads). Legal to ride with any class off-road vehicle.
            </div>
          </div>
        </div>

        <div class="vehicle-class-row closed-row">
          <img
            alt="Trail Closed"
            aria-label="Trail Closed"
            ngSrc="/assets/icons/map-legend-icons/icon-closed-trail.svg"
            i18n-alt
            i18n-aria-label
          />
          <div>
            <div class="title" i18n>Trail Closed</div>
          </div>
        </div>
      </div>
    } @else {
      <div class="left sno-legend">
        <div class="vehicle-class-row">
          <img alt="Trunk" [ngSrc]="trunkImg" i18n-alt />
          <div>
            <div class="title" i18n>Trunk</div>
            <div class="description" i18n>Corridor connecting trails.</div>
          </div>
        </div>

        <div class="vehicle-class-row">
          <img alt="Trail" [ngSrc]="trailImg" i18n-alt />
          <div>
            <div class="title" i18n>Trail</div>
            <div class="description" i18n>Publicly maintained trail.</div>
          </div>
        </div>

        <div class="vehicle-class-row">
          <img alt="Club Trail" [ngSrc]="clubTrailImg" i18n-alt />
          <div>
            <div class="title" i18n>Club Trail</div>
            <div class="description" i18n>Club maintained trail.</div>
          </div>
        </div>

        <div class="vehicle-class-row">
          <img alt="Unmaintained" [ngSrc]="unmaintainedImg" i18n-alt />
          <div>
            <div class="title" i18n>Unmaintained</div>
            <div class="description" i18n>Legal riding opportunity, not maintained.</div>
          </div>
        </div>

        <div class="vehicle-class-row">
          <img alt="Any" [ngSrc]="closedImg" i18n-alt />
          <div>
            <div class="title" i18n>Closed</div>
          </div>
        </div>
      </div>
    }

    <div class="right">
      @if (isOrv) {
        <div class="title" i18n>Trail Difficulty</div>
        <div class="helper-secondary-text" i18n>Where available</div>
        <ul class="list-unstyled trail-difficulty-list">
          <li class="trail-type-layer">
            <img alt="Easy" ngSrc="/assets/icons/trail-difficulty/off-road-easy.svg" i18n-alt />
            <span class="type" i18n>Easy</span>
          </li>
          <li class="trail-type-layer">
            <img alt="Moderate" ngSrc="/assets/icons/trail-difficulty/off-road-moderate.svg" i18n-alt />
            <span class="type" i18n>Moderate</span>
          </li>
          <li class="trail-type-layer">
            <img alt="Difficult" ngSrc="/assets/icons/trail-difficulty/off-road-difficult.svg" i18n-alt />
            <span class="type" i18n>Difficult</span>
          </li>
          <li class="trail-type-layer">
            <img
              class="extreme-icon"
              alt="Extreme"
              ngSrc="/assets/icons/trail-difficulty/off-road-extreme.svg"
              i18n-alt
            />
            <span class="type" i18n>Extreme</span>
          </li>
        </ul>
      }

      <div class="title" i18n>Open Ride Area</div>
      <img class="open-ride-area-image" alt="Open Ride Area" [ngSrc]="openRideArea" i18n-alt />
      @if (isOrv) {
        <div i18n>
          Vehicles may travel anywhere in these areas. Check ride area for allowed vehicles. Color indicates frequently
          ridden locations.
        </div>
      } @else {
        <div i18n>Snowmobiles may travel anywhere in these areas. Color indicates frequently ridden locations.</div>
      }
    </div>
    @if (isOrv) {
      <div class="disclaimer" i18n>
        Class definitions vary by jurisdiction. Always familiarize yourself with local rules and regulations.
      </div>
    }
  </div>
</div>
